import * as orderConstant from './constants'

export const orderReportNvkdRequest = (formData) => {
  return {
    type: orderConstant.ORDER_REPORT_NVKD_REQUESTING,
    formData
  }
}

export const orderReportNvkdSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_NVKD_SUCCESS,
    data
  }
}

export const orderReportNvkdError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_NVKD_ERROR,
    error
  }
}
export const orderReportKhRequest = (formData) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_REQUESTING,
    formData
  }
}

export const orderReportKhSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_SUCCESS,
    data
  }
}

export const orderReportKhError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_ERROR,
    error
  }
}
export const orderReportKhoXuatRequest = (formData) => {
  return {
    type: orderConstant.ORDER_REPORT_KHOXUAT_REQUESTING,
    payload: formData
  }
}

export const orderReportKhoXuatSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_KHOXUAT_SUCCESS,
    data
  }
}

export const orderReportKhoXuatError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_KHOXUAT_ERROR,
    error
  }
}

export const orderReportListRequest = (formData) => {
  return {
    type: orderConstant.ORDER_REPORT_LIST_REQUESTING,
    formData
  }
}

export const orderReportListSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_LIST_SUCCESS,
    data
  }
}

export const orderReportListError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_LIST_ERROR,
    error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: orderConstant.REPORT_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: orderConstant.REPORT_EXPORT_XLS_SUCCESS,
    data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: orderConstant.REPORT_EXPORT_XLS_ERROR,
    error
  }
}

export const orderReportNhomKhRequest = (formData, callback) => {
  return {
    type: orderConstant.ORDER_REPORT_NHOMKH_REQUESTING,
    payload: formData,
    callback
  }
}

export const orderReportNhomKhSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_NHOMKH_SUCCESS,
    data
  }
}

export const orderReportNhomKhError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_NHOMKH_ERROR,
    error
  }
}

export const orderReportKhByNhomRequest = (formData, callback) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_BY_NHOM_REQUESTING,
    payload: formData,
    callback
  }
}

export const orderReportKhByNhomSuccess = (data) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_BY_NHOM_SUCCESS,
    data
  }
}

export const orderReportKhByNhomError = (error) => {
  return {
    type: orderConstant.ORDER_REPORT_KH_BY_NHOM_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/OrderReport/actions.js